



























import { Vue, Component } from 'vue-property-decorator'

import config from '@/config'

@Component
export default class Footer extends Vue {
  private get isMagenta () {
    return config.isMagenta
  }
}
